<template>
<div class="chapter">
<div class="inner_page">
      ﻿





<title>Eddies Bastard</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="epigraphPage" id="epg">
<a id="page09">
<div class="epigraph">
<p class="epigraphText">Just as the mightiest oak topples without its roots, so will a man without knowledge of his people come crashing to earth, dreamless and unfulfilled.</p>
<p class="epigraphText">We cannot hope to understand ourselves until we know something of those who have come before us.</p>
<p class="epigraphSource"><em class="italic">William A. Mann III <br/>from the Diary, c. 1885</em></p>
</div>
</a></div>
<a id="page09">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eddiesbastard_epg.vue?9877a6e0